
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6aa4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6aa4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fmbIX", function(module, exports) {
module.exports = JSON.parse('{"US_STATES":[{"name":"Alabama","tz":"America/Chicago","abbrev":"CT"},{"name":"Alaska","tz":"America/Anchorage","abbrev":"AKT"},{"name":"Arizona","tz":"America/Phoenix","abbrev":"MT"},{"name":"Arkansas","tz":"America/Chicago","abbrev":"CT"},{"name":"California","tz":"America/Los_Angeles","abbrev":"PT"},{"name":"Colorado","tz":"America/Denver","abbrev":"MT"},{"name":"Connecticut","tz":"America/New_York","abbrev":"ET"},{"name":"Delaware","tz":"America/New_York","abbrev":"ET"},{"name":"Florida","tz":"America/New_York","abbrev":"ET"},{"name":"Georgia","tz":"America/New_York","abbrev":"ET"},{"name":"Hawaii","tz":"America/Honolulu","abbrev":"HST"},{"name":"Idaho","tz":"America/Denver","abbrev":"MT"},{"name":"Illinois","tz":"America/Chicago","abbrev":"CT"},{"name":"Indiana","tz":"America/Indiana/Indianapolis","abbrev":"ET"},{"name":"Iowa","tz":"America/Chicago","abbrev":"CT"},{"name":"Kansas","tz":"America/Chicago","abbrev":"CT"},{"name":"Kentucky","tz":"America/New_York","abbrev":"ET"},{"name":"Louisiana","tz":"America/Chicago","abbrev":"CT"},{"name":"Maine","tz":"America/New_York","abbrev":"ET"},{"name":"Maryland","tz":"America/New_York","abbrev":"ET"},{"name":"Massachusetts","tz":"America/New_York","abbrev":"ET"},{"name":"Michigan","tz":"America/Detroit","abbrev":"ET"},{"name":"Minnesota","tz":"America/Chicago","abbrev":"CT"},{"name":"Mississippi","tz":"America/Chicago","abbrev":"CT"},{"name":"Missouri","tz":"America/Chicago","abbrev":"CT"},{"name":"Montana","tz":"America/Denver","abbrev":"MT"},{"name":"Nebraska","tz":"America/Chicago","abbrev":"CT"},{"name":"Nevada","tz":"America/Los_Angeles","abbrev":"PT"},{"name":"New Hampshire","tz":"America/New_York","abbrev":"ET"},{"name":"New Jersey","tz":"America/New_York","abbrev":"ET"},{"name":"New Mexico","tz":"America/Denver","abbrev":"MT"},{"name":"New York","tz":"America/New_York","abbrev":"ET"},{"name":"North Carolina","tz":"America/New_York","abbrev":"ET"},{"name":"North Dakota","tz":"America/Chicago","abbrev":"CT"},{"name":"Ohio","tz":"America/New_York","abbrev":"ET"},{"name":"Oklahoma","tz":"America/Chicago","abbrev":"CT"},{"name":"Oregon","tz":"America/Los_Angeles","abbrev":"PT"},{"name":"Pennsylvania","tz":"America/New_York","abbrev":"ET"},{"name":"Rhode Island","tz":"America/New_York","abbrev":"ET"},{"name":"South Carolina","tz":"America/New_York","abbrev":"ET"},{"name":"South Dakota","tz":"America/Chicago","abbrev":"CT"},{"name":"Tennessee","tz":"America/Chicago","abbrev":"CT"},{"name":"Texas","tz":"America/Chicago","abbrev":"CT"},{"name":"Utah","tz":"America/Denver","abbrev":"MT"},{"name":"Vermont","tz":"America/New_York","abbrev":"ET"},{"name":"Virginia","tz":"America/New_York","abbrev":"ET"},{"name":"Washington","tz":"America/Los_Angeles","abbrev":"PT"},{"name":"West Virginia","tz":"America/New_York","abbrev":"ET"},{"name":"Wisconsin","tz":"America/Chicago","abbrev":"CT"},{"name":"Wyoming","tz":"America/Denver","abbrev":"MT"}],"COUNTRIES":[{"name":"Argentina","tz":"America/Argentina/Buenos_Aires","abbrev":"ART"},{"name":"Australia (Melbourne)","tz":"Australia/Melbourne","abbrev":"AEST/AEDT"},{"name":"Australia (Sydney)","tz":"Australia/Sydney","abbrev":"AEST/AEDT"},{"name":"Brazil (S\xe3o Paulo)","tz":"America/Sao_Paulo","abbrev":"BRT"},{"name":"Canada (Toronto)","tz":"America/Toronto","abbrev":"ET"},{"name":"Canada (Vancouver)","tz":"America/Vancouver","abbrev":"PT"},{"name":"China","tz":"Asia/Shanghai","abbrev":"CST"},{"name":"Egypt","tz":"Africa/Cairo","abbrev":"EET"},{"name":"France","tz":"Europe/Paris","abbrev":"CET/CEST"},{"name":"Germany","tz":"Europe/Berlin","abbrev":"CET/CEST"},{"name":"India","tz":"Asia/Kolkata","abbrev":"IST"},{"name":"Indonesia","tz":"Asia/Jakarta","abbrev":"WIB"},{"name":"Israel","tz":"Asia/Jerusalem","abbrev":"IST"},{"name":"Italy","tz":"Europe/Rome","abbrev":"CET/CEST"},{"name":"Japan","tz":"Asia/Tokyo","abbrev":"JST"},{"name":"Malaysia","tz":"Asia/Kuala_Lumpur","abbrev":"MYT"},{"name":"Mexico (Mexico City)","tz":"America/Mexico_City","abbrev":"CST"},{"name":"New Zealand","tz":"Pacific/Auckland","abbrev":"NZST/NZDT"},{"name":"Philippines","tz":"Asia/Manila","abbrev":"PHT"},{"name":"Russia (Moscow)","tz":"Europe/Moscow","abbrev":"MSK"},{"name":"Saudi Arabia","tz":"Asia/Riyadh","abbrev":"AST"},{"name":"Singapore","tz":"Asia/Singapore","abbrev":"SGT"},{"name":"South Africa","tz":"Africa/Johannesburg","abbrev":"SAST"},{"name":"South Korea","tz":"Asia/Seoul","abbrev":"KST"},{"name":"Spain","tz":"Europe/Madrid","abbrev":"CET/CEST"},{"name":"Thailand","tz":"Asia/Bangkok","abbrev":"ICT"},{"name":"Turkey","tz":"Europe/Istanbul","abbrev":"TRT"},{"name":"United Arab Emirates","tz":"Asia/Dubai","abbrev":"GST"},{"name":"United Kingdom","tz":"Europe/London","abbrev":"GMT/BST"},{"name":"Vietnam","tz":"Asia/Ho_Chi_Minh","abbrev":"ICT"}]}');

});

function $6f019d1f45ba2738$export$2e2bcd8739ae039(targetElements, defaultProps) {
    if (!targetElements.length) return;
    ScrollReveal({
        reset: false
    });
    targetElements.forEach(({ element: element, animation: animation })=>{
        ScrollReveal().reveal(element, Object.assign({}, defaultProps, animation));
    });
}


var $b5f6d4efc654cf78$exports = {};
'use strict';
var $b5f6d4efc654cf78$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
/**
 * Created by Sergiu Șandor (micku7zu) on 1/27/2017.
 * Original idea: https://github.com/gijsroge/tilt.js
 * MIT License.
 * Version 1.8.0
 */ var $b5f6d4efc654cf78$var$VanillaTilt = function() {
    function VanillaTilt(element) {
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $b5f6d4efc654cf78$var$classCallCheck(this, VanillaTilt);
        if (!(element instanceof Node)) throw "Can't initialize VanillaTilt because " + element + " is not a Node.";
        this.width = null;
        this.height = null;
        this.clientWidth = null;
        this.clientHeight = null;
        this.left = null;
        this.top = null;
        // for Gyroscope sampling
        this.gammazero = null;
        this.betazero = null;
        this.lastgammazero = null;
        this.lastbetazero = null;
        this.transitionTimeout = null;
        this.updateCall = null;
        this.event = null;
        this.updateBind = this.update.bind(this);
        this.resetBind = this.reset.bind(this);
        this.element = element;
        this.settings = this.extendSettings(settings);
        this.reverse = this.settings.reverse ? -1 : 1;
        this.resetToStart = VanillaTilt.isSettingTrue(this.settings["reset-to-start"]);
        this.glare = VanillaTilt.isSettingTrue(this.settings.glare);
        this.glarePrerender = VanillaTilt.isSettingTrue(this.settings["glare-prerender"]);
        this.fullPageListening = VanillaTilt.isSettingTrue(this.settings["full-page-listening"]);
        this.gyroscope = VanillaTilt.isSettingTrue(this.settings.gyroscope);
        this.gyroscopeSamples = this.settings.gyroscopeSamples;
        this.elementListener = this.getElementListener();
        if (this.glare) this.prepareGlare();
        if (this.fullPageListening) this.updateClientSize();
        this.addEventListeners();
        this.reset();
        if (this.resetToStart === false) {
            this.settings.startX = 0;
            this.settings.startY = 0;
        }
    }
    VanillaTilt.isSettingTrue = function isSettingTrue(setting) {
        return setting === "" || setting === true || setting === 1;
    };
    /**
   * Method returns element what will be listen mouse events
   * @return {Node}
   */ VanillaTilt.prototype.getElementListener = function getElementListener() {
        if (this.fullPageListening) return window.document;
        if (typeof this.settings["mouse-event-element"] === "string") {
            var mouseEventElement = document.querySelector(this.settings["mouse-event-element"]);
            if (mouseEventElement) return mouseEventElement;
        }
        if (this.settings["mouse-event-element"] instanceof Node) return this.settings["mouse-event-element"];
        return this.element;
    };
    /**
   * Method set listen methods for this.elementListener
   * @return {Node}
   */ VanillaTilt.prototype.addEventListeners = function addEventListeners() {
        this.onMouseEnterBind = this.onMouseEnter.bind(this);
        this.onMouseMoveBind = this.onMouseMove.bind(this);
        this.onMouseLeaveBind = this.onMouseLeave.bind(this);
        this.onWindowResizeBind = this.onWindowResize.bind(this);
        this.onDeviceOrientationBind = this.onDeviceOrientation.bind(this);
        this.elementListener.addEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.addEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.addEventListener("mousemove", this.onMouseMoveBind);
        if (this.glare || this.fullPageListening) window.addEventListener("resize", this.onWindowResizeBind);
        if (this.gyroscope) window.addEventListener("deviceorientation", this.onDeviceOrientationBind);
    };
    /**
   * Method remove event listeners from current this.elementListener
   */ VanillaTilt.prototype.removeEventListeners = function removeEventListeners() {
        this.elementListener.removeEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.removeEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.removeEventListener("mousemove", this.onMouseMoveBind);
        if (this.gyroscope) window.removeEventListener("deviceorientation", this.onDeviceOrientationBind);
        if (this.glare || this.fullPageListening) window.removeEventListener("resize", this.onWindowResizeBind);
    };
    VanillaTilt.prototype.destroy = function destroy() {
        clearTimeout(this.transitionTimeout);
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.reset();
        this.removeEventListeners();
        this.element.vanillaTilt = null;
        delete this.element.vanillaTilt;
        this.element = null;
    };
    VanillaTilt.prototype.onDeviceOrientation = function onDeviceOrientation(event) {
        if (event.gamma === null || event.beta === null) return;
        this.updateElementPosition();
        if (this.gyroscopeSamples > 0) {
            this.lastgammazero = this.gammazero;
            this.lastbetazero = this.betazero;
            if (this.gammazero === null) {
                this.gammazero = event.gamma;
                this.betazero = event.beta;
            } else {
                this.gammazero = (event.gamma + this.lastgammazero) / 2;
                this.betazero = (event.beta + this.lastbetazero) / 2;
            }
            this.gyroscopeSamples -= 1;
        }
        var totalAngleX = this.settings.gyroscopeMaxAngleX - this.settings.gyroscopeMinAngleX;
        var totalAngleY = this.settings.gyroscopeMaxAngleY - this.settings.gyroscopeMinAngleY;
        var degreesPerPixelX = totalAngleX / this.width;
        var degreesPerPixelY = totalAngleY / this.height;
        var angleX = event.gamma - (this.settings.gyroscopeMinAngleX + this.gammazero);
        var angleY = event.beta - (this.settings.gyroscopeMinAngleY + this.betazero);
        var posX = angleX / degreesPerPixelX;
        var posY = angleY / degreesPerPixelY;
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = {
            clientX: posX + this.left,
            clientY: posY + this.top
        };
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseEnter = function onMouseEnter() {
        this.updateElementPosition();
        this.element.style.willChange = "transform";
        this.setTransition();
    };
    VanillaTilt.prototype.onMouseMove = function onMouseMove(event) {
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = event;
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseLeave = function onMouseLeave() {
        this.setTransition();
        if (this.settings.reset) requestAnimationFrame(this.resetBind);
    };
    VanillaTilt.prototype.reset = function reset() {
        this.onMouseEnter();
        if (this.fullPageListening) this.event = {
            clientX: (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.clientWidth,
            clientY: (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.clientHeight
        };
        else this.event = {
            clientX: this.left + (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.width,
            clientY: this.top + (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.height
        };
        var backupScale = this.settings.scale;
        this.settings.scale = 1;
        this.update();
        this.settings.scale = backupScale;
        this.resetGlare();
    };
    VanillaTilt.prototype.resetGlare = function resetGlare() {
        if (this.glare) {
            this.glareElement.style.transform = "rotate(180deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "0";
        }
    };
    VanillaTilt.prototype.getValues = function getValues() {
        var x = void 0, y = void 0;
        if (this.fullPageListening) {
            x = this.event.clientX / this.clientWidth;
            y = this.event.clientY / this.clientHeight;
        } else {
            x = (this.event.clientX - this.left) / this.width;
            y = (this.event.clientY - this.top) / this.height;
        }
        x = Math.min(Math.max(x, 0), 1);
        y = Math.min(Math.max(y, 0), 1);
        var tiltX = (this.reverse * (this.settings.max - x * this.settings.max * 2)).toFixed(2);
        var tiltY = (this.reverse * (y * this.settings.max * 2 - this.settings.max)).toFixed(2);
        var angle = Math.atan2(this.event.clientX - (this.left + this.width / 2), -(this.event.clientY - (this.top + this.height / 2))) * (180 / Math.PI);
        return {
            tiltX: tiltX,
            tiltY: tiltY,
            percentageX: x * 100,
            percentageY: y * 100,
            angle: angle
        };
    };
    VanillaTilt.prototype.updateElementPosition = function updateElementPosition() {
        var rect = this.element.getBoundingClientRect();
        this.width = this.element.offsetWidth;
        this.height = this.element.offsetHeight;
        this.left = rect.left;
        this.top = rect.top;
    };
    VanillaTilt.prototype.update = function update() {
        var values = this.getValues();
        this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(" + (this.settings.axis === "x" ? 0 : values.tiltY) + "deg) " + "rotateY(" + (this.settings.axis === "y" ? 0 : values.tiltX) + "deg) " + "scale3d(" + this.settings.scale + ", " + this.settings.scale + ", " + this.settings.scale + ")";
        if (this.glare) {
            this.glareElement.style.transform = "rotate(" + values.angle + "deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "" + values.percentageY * this.settings["max-glare"] / 100;
        }
        this.element.dispatchEvent(new CustomEvent("tiltChange", {
            "detail": values
        }));
        this.updateCall = null;
    };
    /**
   * Appends the glare element (if glarePrerender equals false)
   * and sets the default style
   */ VanillaTilt.prototype.prepareGlare = function prepareGlare() {
        // If option pre-render is enabled we assume all html/css is present for an optimal glare effect.
        if (!this.glarePrerender) {
            // Create glare element
            var jsTiltGlare = document.createElement("div");
            jsTiltGlare.classList.add("js-tilt-glare");
            var jsTiltGlareInner = document.createElement("div");
            jsTiltGlareInner.classList.add("js-tilt-glare-inner");
            jsTiltGlare.appendChild(jsTiltGlareInner);
            this.element.appendChild(jsTiltGlare);
        }
        this.glareElementWrapper = this.element.querySelector(".js-tilt-glare");
        this.glareElement = this.element.querySelector(".js-tilt-glare-inner");
        if (this.glarePrerender) return;
        Object.assign(this.glareElementWrapper.style, {
            "position": "absolute",
            "top": "0",
            "left": "0",
            "width": "100%",
            "height": "100%",
            "overflow": "hidden",
            "pointer-events": "none",
            "border-radius": "inherit"
        });
        Object.assign(this.glareElement.style, {
            "position": "absolute",
            "top": "50%",
            "left": "50%",
            "pointer-events": "none",
            "background-image": "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            "transform": "rotate(180deg) translate(-50%, -50%)",
            "transform-origin": "0% 0%",
            "opacity": "0"
        });
        this.updateGlareSize();
    };
    VanillaTilt.prototype.updateGlareSize = function updateGlareSize() {
        if (this.glare) {
            var glareSize = (this.element.offsetWidth > this.element.offsetHeight ? this.element.offsetWidth : this.element.offsetHeight) * 2;
            Object.assign(this.glareElement.style, {
                "width": glareSize + "px",
                "height": glareSize + "px"
            });
        }
    };
    VanillaTilt.prototype.updateClientSize = function updateClientSize() {
        this.clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };
    VanillaTilt.prototype.onWindowResize = function onWindowResize() {
        this.updateGlareSize();
        this.updateClientSize();
    };
    VanillaTilt.prototype.setTransition = function setTransition() {
        var _this = this;
        clearTimeout(this.transitionTimeout);
        this.element.style.transition = this.settings.speed + "ms " + this.settings.easing;
        if (this.glare) this.glareElement.style.transition = "opacity " + this.settings.speed + "ms " + this.settings.easing;
        this.transitionTimeout = setTimeout(function() {
            _this.element.style.transition = "";
            if (_this.glare) _this.glareElement.style.transition = "";
        }, this.settings.speed);
    };
    /**
   * Method return patched settings of instance
   * @param {boolean} settings.reverse - reverse the tilt direction
   * @param {number} settings.max - max tilt rotation (degrees)
   * @param {startX} settings.startX - the starting tilt on the X axis, in degrees. Default: 0
   * @param {startY} settings.startY - the starting tilt on the Y axis, in degrees. Default: 0
   * @param {number} settings.perspective - Transform perspective, the lower the more extreme the tilt gets
   * @param {string} settings.easing - Easing on enter/exit
   * @param {number} settings.scale - 2 = 200%, 1.5 = 150%, etc..
   * @param {number} settings.speed - Speed of the enter/exit transition
   * @param {boolean} settings.transition - Set a transition on enter/exit
   * @param {string|null} settings.axis - What axis should be enabled. Can be "x" or "y"
   * @param {boolean} settings.glare - if it should have a "glare" effect
   * @param {number} settings.max-glare - the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
   * @param {boolean} settings.glare-prerender - false = VanillaTilt creates the glare elements for you, otherwise
   * @param {boolean} settings.full-page-listening - If true, parallax effect will listen to mouse move events on the whole document, not only the selected element
   * @param {string|object} settings.mouse-event-element - String selector or link to HTML-element what will be listen mouse events
   * @param {boolean} settings.reset - false = If the tilt effect has to be reset on exit
   * @param {boolean} settings.reset-to-start - true = On reset event (mouse leave) will return to initial start angle (if startX or startY is set)
   * @param {gyroscope} settings.gyroscope - Enable tilting by deviceorientation events
   * @param {gyroscopeSensitivity} settings.gyroscopeSensitivity - Between 0 and 1 - The angle at which max tilt position is reached. 1 = 90deg, 0.5 = 45deg, etc..
   * @param {gyroscopeSamples} settings.gyroscopeSamples - How many gyroscope moves to decide the starting position.
   */ VanillaTilt.prototype.extendSettings = function extendSettings(settings) {
        var defaultSettings = {
            reverse: false,
            max: 15,
            startX: 0,
            startY: 0,
            perspective: 1000,
            easing: "cubic-bezier(.03,.98,.52,.99)",
            scale: 1,
            speed: 300,
            transition: true,
            axis: null,
            glare: false,
            "max-glare": 1,
            "glare-prerender": false,
            "full-page-listening": false,
            "mouse-event-element": null,
            reset: true,
            "reset-to-start": true,
            gyroscope: true,
            gyroscopeMinAngleX: -45,
            gyroscopeMaxAngleX: 45,
            gyroscopeMinAngleY: -45,
            gyroscopeMaxAngleY: 45,
            gyroscopeSamples: 10
        };
        var newSettings = {};
        for(var property in defaultSettings){
            if (property in settings) newSettings[property] = settings[property];
            else if (this.element.hasAttribute("data-tilt-" + property)) {
                var attribute = this.element.getAttribute("data-tilt-" + property);
                try {
                    newSettings[property] = JSON.parse(attribute);
                } catch (e) {
                    newSettings[property] = attribute;
                }
            } else newSettings[property] = defaultSettings[property];
        }
        return newSettings;
    };
    VanillaTilt.init = function init(elements, settings) {
        if (elements instanceof Node) elements = [
            elements
        ];
        if (elements instanceof NodeList) elements = [].slice.call(elements);
        if (!(elements instanceof Array)) return;
        elements.forEach(function(element) {
            if (!("vanillaTilt" in element)) element.vanillaTilt = new VanillaTilt(element, settings);
        });
    };
    return VanillaTilt;
}();
if (typeof document !== "undefined") {
    /* expose the class to window */ window.VanillaTilt = $b5f6d4efc654cf78$var$VanillaTilt;
    /**
   * Auto load
   */ $b5f6d4efc654cf78$var$VanillaTilt.init(document.querySelectorAll("[data-tilt]"));
}
$b5f6d4efc654cf78$exports = $b5f6d4efc654cf78$var$VanillaTilt;


function $b8855ed206bb3c2e$export$2e2bcd8739ae039() {
    const elements = document.querySelectorAll(".js-tilt");
    (0, (/*@__PURE__*/$parcel$interopDefault($b5f6d4efc654cf78$exports))).init(elements);
}


const $d859da13df4a30ff$export$9c21a3269931e1e6 = {
    easing: "cubic-bezier(0.5, 0, 0, 1)",
    distance: "30px",
    duration: 1000,
    desktop: true,
    mobile: true
};
const $d859da13df4a30ff$export$adcf75ad64a03007 = [
    {
        element: ".section-title",
        animation: {
            delay: 200,
            distance: "0px",
            origin: "bottom"
        }
    },
    {
        element: ".hero-title",
        animation: {
            delay: 300,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".social-links",
        animation: {
            delay: 500,
            origin: window.innerWidth > 768 ? "right" : "bottom"
        }
    },
    {
        element: ".hero-cta",
        animation: {
            delay: 750,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".about-wrapper__image",
        animation: {
            delay: 500,
            origin: "bottom"
        }
    },
    {
        element: ".about-wrapper__info",
        animation: {
            delay: 750,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".project-wrapper__text",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".project-wrapper__image",
        animation: {
            delay: 500,
            origin: window.innerWidth > 768 ? "right" : "bottom"
        }
    },
    {
        element: ".review-carousel",
        animation: {
            delay: 500,
            origin: window.innerWidth > 768 ? "left" : "bottom",
            distance: "30px"
        }
    },
    {
        element: ".contact-wrapper",
        animation: {
            delay: 750,
            origin: "bottom"
        }
    },
    {
        element: ".steps-wrapper",
        animation: {
            delay: 500,
            origin: "bottom"
        }
    }
];


/**
 * @file bookingForm.js
 * Main booking entry point.
 */ /**
 * @file utils.js
 * Contains shared utility functions used across the application.
 */ /**
 * Generates a random 6-character booking code.
 * @returns {string} The generated booking code.
 */ function $fa1e525c94b2273d$export$54d94b730ee00606() {
    const chars = "ABCDEFGHIJKLMNPQRSTUVWXYZ0123456789";
    let result = "";
    for(let i = 0; i < 6; i++)result += chars.charAt(Math.floor(Math.random() * chars.length));
    return result;
}
function $fa1e525c94b2273d$export$4afef03e60e8adb5() {
    const timezoneElement = document.getElementById("user_timezone");
    if (timezoneElement) timezoneElement.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function $fa1e525c94b2273d$export$13b5e79461cd05b3(monthSelect, year, isInvalidDate) {
    const originalValue = monthSelect.value;
    const placeholder = monthSelect.options[0];
    const allMonths = Array.from(monthSelect.options).slice(1).map((opt)=>({
            value: opt.value,
            text: opt.textContent
        }));
    monthSelect.innerHTML = "";
    monthSelect.appendChild(placeholder);
    const isPastCheck = isInvalidDate(new Date("1970-01-01"));
    const checkMonthValidity = (month)=>{
        let testDate;
        if (isPastCheck) testDate = new Date(year, month, 0); // Use last day of month for past checks
        else testDate = new Date(year, month - 1, 1); // Use first day of month for future checks
        return isInvalidDate(testDate);
    };
    allMonths.forEach((monthInfo)=>{
        const month = parseInt(monthInfo.value);
        if (!checkMonthValidity(month)) {
            const option = document.createElement("option");
            option.value = monthInfo.value;
            option.textContent = monthInfo.text;
            monthSelect.appendChild(option);
        }
    });
    monthSelect.value = originalValue;
    if (monthSelect.selectedIndex === -1 || monthSelect.value === "") monthSelect.value = "";
}
function $fa1e525c94b2273d$export$5372c0a67990e689(daySelect, month, year, isInvalidDate) {
    const daysInMonth = new Date(year, month, 0).getDate();
    const originalValue = daySelect.value;
    const placeholder = daySelect.options[0];
    daySelect.innerHTML = "";
    daySelect.appendChild(placeholder);
    for(let day = 1; day <= daysInMonth; day++){
        const testDate = new Date(year, month - 1, day);
        if (!isInvalidDate(testDate)) {
            const option = document.createElement("option");
            option.value = day;
            option.textContent = day;
            daySelect.appendChild(option);
        }
    }
    daySelect.value = originalValue;
    if (daySelect.selectedIndex === -1 || daySelect.value === "") daySelect.value = "";
}


/**
 * @file birthdate.js
 * Handles the logic for the birthdate selection and zodiac calculation.
 */ /**
 * @file zodiac.js
 * Contains data and logic for Chinese zodiac calculations and Thai month names.
 */ const $7dc82dfee212df08$export$3f890bd9591ea8c = {
    1: "\u0E21.\u0E04.",
    2: "\u0E01.\u0E1E.",
    3: "\u0E21\u0E35.\u0E04.",
    4: "\u0E40\u0E21.\u0E22.",
    5: "\u0E1E.\u0E04.",
    6: "\u0E21\u0E34.\u0E22.",
    7: "\u0E01.\u0E04.",
    8: "\u0E2A.\u0E04.",
    9: "\u0E01.\u0E22.",
    10: "\u0E15.\u0E04.",
    11: "\u0E1E.\u0E22.",
    12: "\u0E18.\u0E04."
};
const $7dc82dfee212df08$var$ZODIAC_ANIMALS = [
    {
        thai: "\u0E1B\u0E35\u0E0A\u0E27\u0E14 (\u0E2B\u0E19\u0E39)",
        english: "Rat"
    },
    {
        thai: "\u0E1B\u0E35\u0E09\u0E25\u0E39 (\u0E27\u0E31\u0E27)",
        english: "Ox"
    },
    {
        thai: "\u0E1B\u0E35\u0E02\u0E32\u0E25 (\u0E40\u0E2A\u0E37\u0E2D)",
        english: "Tiger"
    },
    {
        thai: "\u0E1B\u0E35\u0E40\u0E16\u0E32\u0E30 (\u0E01\u0E23\u0E30\u0E15\u0E48\u0E32\u0E22)",
        english: "Rabbit"
    },
    {
        thai: "\u0E1B\u0E35\u0E21\u0E30\u0E42\u0E23\u0E07 (\u0E21\u0E31\u0E07\u0E01\u0E23 / \u0E07\u0E39\u0E43\u0E2B\u0E0D\u0E48)",
        english: "Dragon"
    },
    {
        thai: "\u0E1B\u0E35\u0E21\u0E30\u0E40\u0E2A\u0E47\u0E07 (\u0E07\u0E39\u0E40\u0E25\u0E47\u0E01)",
        english: "Snake"
    },
    {
        thai: "\u0E1B\u0E35\u0E21\u0E30\u0E40\u0E21\u0E35\u0E22 (\u0E21\u0E49\u0E32)",
        english: "Horse"
    },
    {
        thai: "\u0E1B\u0E35\u0E21\u0E30\u0E41\u0E21 (\u0E41\u0E1E\u0E30)",
        english: "Goat"
    },
    {
        thai: "\u0E1B\u0E35\u0E27\u0E2D\u0E01 (\u0E25\u0E34\u0E07)",
        english: "Monkey"
    },
    {
        thai: "\u0E1B\u0E35\u0E23\u0E30\u0E01\u0E32 (\u0E44\u0E01\u0E48)",
        english: "Rooster"
    },
    {
        thai: "\u0E1B\u0E35\u0E08\u0E2D (\u0E2A\u0E38\u0E19\u0E31\u0E02 / \u0E2B\u0E21\u0E32)",
        english: "Dog"
    },
    {
        thai: "\u0E1B\u0E35\u0E01\u0E38\u0E19 (\u0E2B\u0E21\u0E39)",
        english: "Pig"
    }
];
function $7dc82dfee212df08$export$68a4b841c92409c1(year) {
    const offset = 4; // Align cycle so that 1996 is Rat
    const index = (year - offset) % 12;
    const animal = $7dc82dfee212df08$var$ZODIAC_ANIMALS[(index + 12) % 12];
    return `${animal.thai} / ${animal.english}`;
}



const $b8f4f765ee223ca8$var$birthDaySelect = document.getElementById("birth_day");
const $b8f4f765ee223ca8$var$birthMonthSelect = document.getElementById("birth_month");
const $b8f4f765ee223ca8$var$birthYearSelect = document.getElementById("birth_year");
/**
 * Populates the birth day and year dropdowns.
 */ function $b8f4f765ee223ca8$var$populateBirthdateDropdowns() {
    for(let day = 1; day <= 31; day++){
        const option = document.createElement("option");
        option.value = day;
        option.textContent = day;
        $b8f4f765ee223ca8$var$birthDaySelect.appendChild(option);
    }
    const currentYear = new Date().getFullYear();
    const currentBuddhistYear = currentYear + 543;
    for(let i = 0; i <= 120; i++){
        const buddhistYear = currentBuddhistYear - i;
        const gregorianYear = buddhistYear - 543;
        const option = document.createElement("option");
        option.value = gregorianYear;
        option.textContent = buddhistYear;
        $b8f4f765ee223ca8$var$birthYearSelect.appendChild(option);
    }
}
/**
 * Validation rule for birth dates. Returns true if the date is in the future.
 */ function $b8f4f765ee223ca8$var$isInvalidBirthDate(date) {
    return date > new Date();
}
/**
 * Updates the hidden birth date field and the Chinese zodiac field.
 */ function $b8f4f765ee223ca8$var$updateBirthDate() {
    const hiddenBirthDate = document.getElementById("hidden_birth_date");
    const zodiacInput = document.getElementById("chinese_zodiac");
    const day = $b8f4f765ee223ca8$var$birthDaySelect.value;
    const month = $b8f4f765ee223ca8$var$birthMonthSelect.value;
    const year = $b8f4f765ee223ca8$var$birthYearSelect.value;
    if (day && month && year) {
        const buddhistYear = parseInt(year) + 543;
        const monthName = (0, $7dc82dfee212df08$export$3f890bd9591ea8c)[parseInt(month)];
        hiddenBirthDate.value = `${day} ${monthName} ${buddhistYear}`;
        zodiacInput.value = (0, $7dc82dfee212df08$export$68a4b841c92409c1)(parseInt(year));
    } else {
        hiddenBirthDate.value = "";
        zodiacInput.value = "";
    }
}
function $b8f4f765ee223ca8$var$handleDateChange() {
    const year = parseInt($b8f4f765ee223ca8$var$birthYearSelect.value);
    const month = parseInt($b8f4f765ee223ca8$var$birthMonthSelect.value);
    if (year) (0, $fa1e525c94b2273d$export$13b5e79461cd05b3)($b8f4f765ee223ca8$var$birthMonthSelect, year, $b8f4f765ee223ca8$var$isInvalidBirthDate);
    if (year && month) (0, $fa1e525c94b2273d$export$5372c0a67990e689)($b8f4f765ee223ca8$var$birthDaySelect, month, year, $b8f4f765ee223ca8$var$isInvalidBirthDate);
    $b8f4f765ee223ca8$var$updateBirthDate();
}
function $b8f4f765ee223ca8$export$fd2d1ddfa9193fe4() {
    if (!$b8f4f765ee223ca8$var$birthDaySelect || !$b8f4f765ee223ca8$var$birthMonthSelect || !$b8f4f765ee223ca8$var$birthYearSelect) return;
    // Clear previous options if re-initializing
    $b8f4f765ee223ca8$var$birthDaySelect.innerHTML = '<option value="" disabled selected>\u0E27\u0E31\u0E19</option>';
    $b8f4f765ee223ca8$var$birthYearSelect.innerHTML = '<option value="" disabled selected>\u0E1B\u0E35</option>';
    $b8f4f765ee223ca8$var$populateBirthdateDropdowns();
    $b8f4f765ee223ca8$var$handleDateChange();
    [
        $b8f4f765ee223ca8$var$birthYearSelect,
        $b8f4f765ee223ca8$var$birthMonthSelect,
        $b8f4f765ee223ca8$var$birthDaySelect
    ].forEach((el)=>el.addEventListener("change", $b8f4f765ee223ca8$var$handleDateChange));
}


/**
 * @file appointment.js
 * Handles the logic for the appointment date and time selection.
 */ 
const $e8e79bda60d9189f$export$4db2a0f799e0c520 = {
    // timeZone: "America/Chicago",
    timeZone: "America/Los_Angeles",
    // timeZone: "Asia/Bangkok",
    availability: {
        // Sunday: { start: { hour: 9, minute: 0 }, end: { hour: 21, minute: 0 } },
        // Tuesday: { start: { hour: 9, minute: 15 }, end: { hour: 21, minute: 0 } },
        // Saturday: { start: null, end: null },
        // Saturday: { start: { hour: null, minute: null }, end: { hour: null, minute: null } },
        Sunday: {
            start: {
                hour: 8,
                minute: 0
            },
            end: {
                hour: 22,
                minute: 0
            }
        },
        Monday: {
            start: {
                hour: 8,
                minute: 0
            },
            end: {
                hour: 22,
                minute: 0
            }
        },
        Tuesday: {
            start: {
                hour: 8,
                minute: 0
            },
            end: {
                hour: 22,
                minute: 0
            }
        },
        Wednesday: {
            start: {
                hour: 8,
                minute: 0
            },
            end: {
                hour: 22,
                minute: 0
            }
        },
        Thursday: {
            start: {
                hour: 8,
                minute: 0
            },
            end: {
                hour: 22,
                minute: 0
            }
        },
        Friday: {
            start: {
                hour: 8,
                minute: 0
            },
            end: {
                hour: 22,
                minute: 0
            }
        },
        Saturday: {
            start: {
                hour: 8,
                minute: 0
            },
            end: {
                hour: 22,
                minute: 0
            }
        }
    },
    interval: 15
};
const $e8e79bda60d9189f$var$daySelect = document.getElementById("day-select");
const $e8e79bda60d9189f$var$monthSelect = document.getElementById("month-select");
const $e8e79bda60d9189f$var$yearSelect = document.getElementById("year-select");
const $e8e79bda60d9189f$var$timepicker = document.getElementById("timepicker");
/**
 * Populates the appointment day and year dropdowns.
 */ function $e8e79bda60d9189f$var$populateAppointmentDropdowns() {
    const currentYear = new Date().getFullYear();
    const currentBuddhistYear = currentYear + 543;
    for(let day = 1; day <= 31; day++){
        const option = document.createElement("option");
        option.value = day;
        option.textContent = day;
        $e8e79bda60d9189f$var$daySelect.appendChild(option);
    }
    for(let i = 0; i <= 1; i++){
        const buddhistYear = currentBuddhistYear + i;
        const gregorianYear = buddhistYear - 543;
        const option = document.createElement("option");
        option.value = gregorianYear;
        option.textContent = buddhistYear;
        if (gregorianYear === currentYear) option.selected = true;
        $e8e79bda60d9189f$var$yearSelect.appendChild(option);
    }
}
/**
 * Validation rule for appointment dates. Returns true if the date is in the past.
 */ function $e8e79bda60d9189f$var$isInvalidAppointmentDate(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
}
/**
 * Checks if current time is past the last available appointment slot
 */ function $e8e79bda60d9189f$var$isPastLastAppointmentSlot() {
    const now = new Date();
    const dayOfWeek = now.toLocaleDateString("en-US", {
        weekday: "long"
    });
    const todayAvailability = $e8e79bda60d9189f$export$4db2a0f799e0c520.availability[dayOfWeek];
    if (!todayAvailability || !todayAvailability.end || todayAvailability.end.hour === null) return true; // No availability defined for today
    const currentTimeInMinutes = now.getHours() * 60 + now.getMinutes();
    // Calculate the last appointment slot in local time
    const lastTexasHour = todayAvailability.end.hour;
    const lastTexasMinute = todayAvailability.end.minute - $e8e79bda60d9189f$export$4db2a0f799e0c520.interval;
    const lastTexasDT = luxon.DateTime.fromObject({
        hour: lastTexasHour,
        minute: lastTexasMinute
    }, {
        zone: $e8e79bda60d9189f$export$4db2a0f799e0c520.timeZone
    });
    const lastLocalDT = lastTexasDT.setZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const lastSlotTimeInMinutes = lastLocalDT.hour * 60 + lastLocalDT.minute;
    return currentTimeInMinutes > lastSlotTimeInMinutes;
}
/**
 * Gets the appropriate default date (today or tomorrow based on current time)
 */ function $e8e79bda60d9189f$var$getDefaultDate() {
    const today = new Date();
    if ($e8e79bda60d9189f$var$isPastLastAppointmentSlot()) {
        // If past last appointment slot, default to tomorrow
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        return tomorrow;
    }
    return today;
}
/**
 * Updates the validity of time slots by rebuilding the dropdown.
 * This version removes/re-adds options to support iOS.
 */ function $e8e79bda60d9189f$var$updateValidTimeSlots() {
    const day = parseInt($e8e79bda60d9189f$var$daySelect.value);
    const month = parseInt($e8e79bda60d9189f$var$monthSelect.value);
    const year = parseInt($e8e79bda60d9189f$var$yearSelect.value);
    const originalValue = $e8e79bda60d9189f$var$timepicker.value;
    const placeholder = $e8e79bda60d9189f$var$timepicker.querySelector('option[value=""]');
    $e8e79bda60d9189f$var$timepicker.disabled = false;
    if (placeholder) placeholder.textContent = "\u0E40\u0E27\u0E25\u0E32"; // Reset placeholder text
    $e8e79bda60d9189f$var$timepicker.innerHTML = "";
    if (placeholder) $e8e79bda60d9189f$var$timepicker.appendChild(placeholder);
    if (!day || !month || !year) return;
    const selectedDate = new Date(year, month - 1, day);
    const dayOfWeek = selectedDate.toLocaleDateString("en-US", {
        weekday: "long"
    });
    const availability = $e8e79bda60d9189f$export$4db2a0f799e0c520.availability[dayOfWeek];
    let hasAvailableSlots = false;
    if (availability && availability.start && availability.end && availability.start.hour !== null && availability.end.hour !== null) {
        const today = new Date();
        const isToday = selectedDate.toDateString() === today.toDateString();
        const currentTimeInMinutes = today.getHours() * 60 + today.getMinutes();
        const blockDurationInMinutes = 480; // 8 hours
        for(let hour = availability.start.hour; hour <= availability.end.hour; hour++){
            const startMin = hour === availability.start.hour ? availability.start.minute : 0;
            const endMin = hour === availability.end.hour ? availability.end.minute : 60;
            for(let min = startMin; min < endMin; min += $e8e79bda60d9189f$export$4db2a0f799e0c520.interval){
                const texasDT = luxon.DateTime.fromObject({
                    hour: hour,
                    minute: min
                }, {
                    zone: $e8e79bda60d9189f$export$4db2a0f799e0c520.timeZone
                });
                const localDT = texasDT.setZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
                const optionTimeInMinutes = localDT.hour * 60 + localDT.minute;
                if (!isToday || isToday && optionTimeInMinutes > currentTimeInMinutes + blockDurationInMinutes) {
                    const option = document.createElement("option");
                    option.value = localDT.toFormat("HH:mm");
                    option.textContent = localDT.toFormat("HH:mm");
                    option.dataset.texas = texasDT.toFormat("HH:mm");
                    $e8e79bda60d9189f$var$timepicker.appendChild(option);
                    hasAvailableSlots = true;
                }
            }
        }
    }
    if (!hasAvailableSlots) {
        if (placeholder) placeholder.textContent = "\u0E04\u0E34\u0E27\u0E40\u0E15\u0E47\u0E21\u0E41\u0E25\u0E49\u0E27 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E27\u0E31\u0E19\u0E15\u0E48\u0E2D\u0E44\u0E1B";
        $e8e79bda60d9189f$var$timepicker.disabled = true;
    }
    $e8e79bda60d9189f$var$timepicker.value = originalValue;
    if ($e8e79bda60d9189f$var$timepicker.selectedIndex === -1) $e8e79bda60d9189f$var$timepicker.value = "";
}
/**
 * Updates the hidden date field with the ISO date string.
 */ function $e8e79bda60d9189f$var$updateHiddenDate() {
    const hiddenDate = document.getElementById("hidden-date");
    const day = $e8e79bda60d9189f$var$daySelect.value;
    const month = $e8e79bda60d9189f$var$monthSelect.value;
    const year = $e8e79bda60d9189f$var$yearSelect.value;
    hiddenDate.value = day && month && year ? `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}` : "";
}
function $e8e79bda60d9189f$var$handleDateChange() {
    const year = parseInt($e8e79bda60d9189f$var$yearSelect.value);
    const month = parseInt($e8e79bda60d9189f$var$monthSelect.value);
    if (year) (0, $fa1e525c94b2273d$export$13b5e79461cd05b3)($e8e79bda60d9189f$var$monthSelect, year, $e8e79bda60d9189f$var$isInvalidAppointmentDate);
    if (year && month) (0, $fa1e525c94b2273d$export$5372c0a67990e689)($e8e79bda60d9189f$var$daySelect, month, year, $e8e79bda60d9189f$var$isInvalidAppointmentDate);
    $e8e79bda60d9189f$var$updateValidTimeSlots();
    $e8e79bda60d9189f$var$updateHiddenDate();
}
function $e8e79bda60d9189f$export$3604f5fb8154211() {
    if (!$e8e79bda60d9189f$var$daySelect || !$e8e79bda60d9189f$var$monthSelect || !$e8e79bda60d9189f$var$yearSelect || !$e8e79bda60d9189f$var$timepicker) return;
    $e8e79bda60d9189f$var$populateAppointmentDropdowns();
    // Use the smart default date (today or tomorrow based on current time)
    const defaultDate = $e8e79bda60d9189f$var$getDefaultDate();
    $e8e79bda60d9189f$var$monthSelect.value = defaultDate.getMonth() + 1;
    $e8e79bda60d9189f$var$daySelect.value = defaultDate.getDate();
    // If using tomorrow and it's in a different year, update the year
    if (defaultDate.getFullYear() !== new Date().getFullYear()) $e8e79bda60d9189f$var$yearSelect.value = defaultDate.getFullYear();
    $e8e79bda60d9189f$var$handleDateChange(); // This will now correctly populate the time slots on initial load
    [
        $e8e79bda60d9189f$var$yearSelect,
        $e8e79bda60d9189f$var$monthSelect,
        $e8e79bda60d9189f$var$daySelect
    ].forEach((el)=>el.addEventListener("change", $e8e79bda60d9189f$var$handleDateChange));
    $e8e79bda60d9189f$var$timepicker.addEventListener("change", ()=>{
        const selected = $e8e79bda60d9189f$var$timepicker.selectedOptions[0];
        const texasDatetimeEl = document.getElementById("texas_datetime");
        if (texasDatetimeEl && selected) texasDatetimeEl.value = selected.dataset.texas;
    });
}


/**
 * @file submission.js
 * Handles form validation and submission logic.
 */ 




var $fmbIX = parcelRequire("fmbIX");
const $58d30a8bb9adbbf5$var$form = document.getElementById("bookingForm");
const $58d30a8bb9adbbf5$var$nameInput = document.querySelector("input[name='name']");
const $58d30a8bb9adbbf5$var$hiddenDate = document.getElementById("hidden-date");
const $58d30a8bb9adbbf5$var$timepicker = document.getElementById("timepicker");
/**
 * Resolves a friendly display name for a given timezone.
 * @param {string} tz - IANA timezone identifier.
 * @returns {string} Friendly location name.
 */ function $58d30a8bb9adbbf5$var$getTimezoneName(tz) {
    if (!tz) return "-";
    if (tz === "Asia/Bangkok") return "\u0E44\u0E17\u0E22";
    if (tz === "America/Los_Angeles") return "Washington";
    if (tz === "America/Chicago") return "Texas";
    if (tz === "America/New_York") return "New York";
    if (tz === "America/Denver") return "Denver";
    if (tz === "America/Phoenix") return "Arizona";
    const country = (0, (/*@__PURE__*/$parcel$interopDefault($fmbIX)))?.COUNTRIES?.find((c)=>c.tz === tz);
    if (country) return country.name;
    const state = (0, (/*@__PURE__*/$parcel$interopDefault($fmbIX)))?.US_STATES?.find((s)=>s.tz === tz);
    if (state) return state.name;
    return tz.includes("/") ? tz.split("/").pop().replace(/_/g, " ") : tz;
}
/**
 * Formats dates for submission and converts to the configured host timezone.
 */ function $58d30a8bb9adbbf5$var$formatDatesForSubmission(dateVal, timeVal) {
    const [hours, minutes] = timeVal.split(":").map(Number);
    const userZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Bangkok";
    const hostZone = (0, $e8e79bda60d9189f$export$4db2a0f799e0c520)?.timeZone || "America/Los_Angeles";
    const dt = luxon.DateTime.fromISO(dateVal, {
        zone: userZone
    }).set({
        hour: hours,
        minute: minutes
    });
    const formattedDate = `${dt.day} ${(0, $7dc82dfee212df08$export$3f890bd9591ea8c)[dt.month]} ${dt.year + 543}`;
    const formattedTime = dt.toFormat("HH:mm");
    const hostDT = dt.setZone(hostZone);
    const hostFormatted = `${hostDT.day} ${(0, $7dc82dfee212df08$export$3f890bd9591ea8c)[hostDT.month]} ${hostDT.year + 543} \u{E40}\u{E27}\u{E25}\u{E32} ${hostDT.toFormat("HH:mm")} \u{E19}.`;
    return {
        formattedDate: formattedDate,
        formattedTime: formattedTime,
        hostFormatted: hostFormatted,
        userZone: userZone,
        hostZone: hostZone
    };
}
function $58d30a8bb9adbbf5$export$7a49bbb4b7f656ab(bookingCode) {
    Swal.fire({
        icon: "success",
        title: "<b>\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E08\u0E2D\u0E07\u0E04\u0E34\u0E27</b>",
        html: `
      <p>\u{E01}\u{E23}\u{E38}\u{E13}\u{E32}\u{E08}\u{E14}\u{E23}\u{E2B}\u{E31}\u{E2A}\u{E01}\u{E32}\u{E23}\u{E08}\u{E2D}\u{E07}\u{E44}\u{E27}\u{E49}: <strong style="color: red;">${bookingCode}</strong></p>
      <p>\u{E04}\u{E23}\u{E39}\u{E1E}\u{E25}\u{E2D}\u{E22}\u{E08}\u{E30}\u{E04}\u{E2D}\u{E19}\u{E40}\u{E1F}\u{E34}\u{E23}\u{E4C}\u{E21}\u{E20}\u{E32}\u{E22}\u{E43}\u{E19} <b>12 \u{E0A}\u{E21}</b> \u{E1C}\u{E48}\u{E32}\u{E19}\u{E17}\u{E32}\u{E07}\u{E44}\u{E25}\u{E19}\u{E4C}</p>
      <p>
        \u{E42}\u{E1B}\u{E23}\u{E14}\u{E41}\u{E2D}\u{E14}\u{E44}\u{E25}\u{E19}\u{E4C} \u{E17}\u{E35}\u{E48} ID Line:
        <span class="text-color-main"><strong>ploy.tip</strong></span>
      </p>
      <p>
        \u{E2B}\u{E23}\u{E37}\u{E2D}\u{E01}\u{E14}\u{E17}\u{E35}\u{E48}\u{E19}\u{E35}\u{E48}
        <a rel="noreferrer" href="https://line.me/ti/p/hJdG41iKRb" target="_blank">
          <i class="fab fa-line fa-2x"></i>
        </a>
      </p>
      <p><strong>\u{E43}\u{E19}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07}\u{E19}\u{E35}\u{E49} \u{E42}\u{E1B}\u{E23}\u{E14}\u{E2D}\u{E48}\u{E32}\u{E19}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E40}\u{E1E}\u{E34}\u{E48}\u{E21}\u{E40}\u{E15}\u{E34}\u{E21}\u{E14}\u{E49}\u{E32}\u{E19}\u{E25}\u{E48}\u{E32}\u{E07}</strong></p>
      <p>
        <a href="steps.html" class="cta-btn cta-btn--hero" target="_blank">
          \u{E02}\u{E31}\u{E49}\u{E19}\u{E15}\u{E2D}\u{E19}\u{E01}\u{E32}\u{E23}\u{E14}\u{E39}\u{E44}\u{E1E}\u{E48}\u{E22}\u{E34}\u{E1B}\u{E0B}\u{E35}\u{E2D}\u{E2D}\u{E19}\u{E44}\u{E25}\u{E19}\u{E4C}
        </a>
      </p>
    `,
        showConfirmButton: false,
        showCloseButton: true
    });
    if ($58d30a8bb9adbbf5$var$form) $58d30a8bb9adbbf5$var$form.reset();
    [
        "hidden-date",
        "hidden_birth_date",
        "chinese_zodiac"
    ].forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.value = "";
    });
    // Re-initialize the forms to reset their state
    (0, $b8f4f765ee223ca8$export$fd2d1ddfa9193fe4)();
    (0, $e8e79bda60d9189f$export$3604f5fb8154211)();
}
/**
 * Handles a form submission error.
 */ function $58d30a8bb9adbbf5$var$handleFormError() {
    Swal.fire({
        icon: "error",
        title: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E48\u0E07\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E14\u0E49",
        html: `
    <p>\u{E02}\u{E2D}\u{E2D}\u{E20}\u{E31}\u{E22}\u{E43}\u{E19}\u{E04}\u{E27}\u{E32}\u{E21}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E30}\u{E14}\u{E27}\u{E01} \u{E23}\u{E30}\u{E1A}\u{E1A}\u{E21}\u{E35}\u{E1B}\u{E31}\u{E0D}\u{E2B}\u{E32}\u{E43}\u{E19}\u{E01}\u{E32}\u{E23}\u{E2A}\u{E48}\u{E07}\u{E1F}\u{E2D}\u{E23}\u{E4C}\u{E21}\u{E02}\u{E2D}\u{E07}\u{E04}\u{E38}\u{E13}
       \u{E01}\u{E23}\u{E38}\u{E13}\u{E32}\u{E41}\u{E2D}\u{E14}\u{E44}\u{E25}\u{E19}\u{E4C}\u{E40}\u{E1E}\u{E37}\u{E48}\u{E2D}\u{E17}\u{E33}\u{E01}\u{E32}\u{E23}\u{E08}\u{E2D}\u{E07}\u{E04}\u{E34}\u{E27} \u{E17}\u{E35}\u{E48} <br/> ID Line:
      <span class="text-color-main"><strong>ploy.tip</strong></span>
      <br/>\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E01}\u{E14}\u{E17}\u{E35}\u{E48}\u{E19}\u{E35}\u{E48}
      <a rel="noreferrer" href="https://line.me/ti/p/hJdG41iKRb" target="_blank">
        <i class="fab fa-line fa-2x"></i>
      </a>
    </p>
    <h2>\u{E02}\u{E2D}\u{E1A}\u{E04}\u{E38}\u{E13}\u{E04}\u{E48}\u{E30}</h2>
  `,
        confirmButtonText: "\u0E15\u0E01\u0E25\u0E07"
    });
}
function $58d30a8bb9adbbf5$export$9ba86a8937f38dd() {
    // Ensure DOM is ready
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", $58d30a8bb9adbbf5$export$9ba86a8937f38dd);
        return;
    }
    const form = document.getElementById("bookingForm");
    if (!form) {
        console.warn('Form with ID "bookingForm" not found');
        return;
    }
    form.addEventListener("submit", async (e)=>{
        e.preventDefault();
        // Get fresh references to elements
        const hiddenDate = document.getElementById("hidden-date");
        const timepicker = document.getElementById("timepicker");
        const nameInput = document.querySelector("input[name='name']");
        // Add null checks for required elements
        if (!hiddenDate) {
            console.error("Hidden date element not found");
            return;
        }
        if (!timepicker) {
            console.error("Timepicker element not found");
            return;
        }
        if (!nameInput) {
            console.error("Name input element not found");
            return;
        }
        const dateVal = hiddenDate.value;
        const timeVal = timepicker.value;
        const name = nameInput.value.trim();
        const bookingCode = (0, $fa1e525c94b2273d$export$54d94b730ee00606)();
        // Add null checks for form elements
        const bookingCodeElement = document.getElementById("booking_code");
        const subjectElement = document.getElementById("subject");
        const texasDatetimeElement = document.getElementById("texas_datetime");
        if (bookingCodeElement) bookingCodeElement.value = bookingCode;
        if (subjectElement) subjectElement.value = `\u{E08}\u{E2D}\u{E07}\u{E04}\u{E34}\u{E27} - ${name} - ${bookingCode}`;
        const { formattedDate: formattedDate, formattedTime: formattedTime, hostFormatted: hostFormatted, userZone: userZone, hostZone: hostZone } = $58d30a8bb9adbbf5$var$formatDatesForSubmission(dateVal, timeVal);
        hiddenDate.value = formattedDate;
        if (texasDatetimeElement) texasDatetimeElement.value = hostFormatted;
        const serviceSelect = form.querySelector("select[name='service']");
        const service = serviceSelect?.value || "-";
        const birthDateInput = document.getElementById("hidden_birth_date");
        const birthDate = birthDateInput?.value || "-";
        const zodiacInput = document.getElementById("chinese_zodiac");
        const zodiac = zodiacInput?.value || "-";
        const isSameZone = userZone === hostZone;
        const userTzName = $58d30a8bb9adbbf5$var$getTimezoneName(userZone);
        const hostTzName = $58d30a8bb9adbbf5$var$getTimezoneName(hostZone);
        const timeLines = isSameZone ? [
            `\u{E08}\u{E2D}\u{E07}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} ${formattedDate} \u{E40}\u{E27}\u{E25}\u{E32} ${formattedTime} \u{E19}. \u{E43}\u{E19}\u{E40}\u{E02}\u{E15}\u{E40}\u{E27}\u{E25}\u{E32}\u{E02}\u{E2D}\u{E07} ${hostTzName}`
        ] : [
            `\u{E08}\u{E2D}\u{E07}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} ${formattedDate} \u{E40}\u{E27}\u{E25}\u{E32} ${formattedTime} \u{E19}. \u{E43}\u{E19}\u{E40}\u{E02}\u{E15}\u{E40}\u{E27}\u{E25}\u{E32}\u{E02}\u{E2D}\u{E07} ${userTzName}`,
            `\u{E0B}\u{E36}\u{E48}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} ${hostFormatted} \u{E43}\u{E19}\u{E40}\u{E02}\u{E15}\u{E40}\u{E27}\u{E25}\u{E32}\u{E02}\u{E2D}\u{E07} ${hostTzName}`
        ];
        const messageText = [
            `\u{E27}\u{E31}\u{E19}\u{E19}\u{E35}\u{E49}\u{E21}\u{E35}\u{E04}\u{E19}\u{E0A}\u{E37}\u{E48}\u{E2D} ${name}`,
            ...timeLines,
            `\u{E04}\u{E48}\u{E32}\u{E04}\u{E23}\u{E39} ${service}`,
            `\u{E40}\u{E01}\u{E34}\u{E14}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48} ${birthDate}`,
            `\u{E1B}\u{E35}\u{E19}\u{E31}\u{E01}\u{E29}\u{E31}\u{E15}\u{E23} ${zodiac}`
        ].join("\n");
        const submissionData = new FormData();
        submissionData.append("_captcha", "false");
        submissionData.append("_subject", `\u{E08}\u{E2D}\u{E07}\u{E04}\u{E34}\u{E27} - ${name} - ${bookingCode}`);
        submissionData.append("\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21", messageText);
        submissionData.append("\u0E23\u0E2B\u0E31\u0E2A\u0E01\u0E32\u0E23\u0E08\u0E2D\u0E07", bookingCode);
        // Try multiple selectors to find the submit button after build
        let submitButton = form.querySelector('button[type="submit"]') || form.querySelector('input[type="submit"]') || form.querySelector("button:last-of-type") || form.querySelector('[type="submit"]') || form.querySelector("button");
        if (submitButton) {
            // Store original text for restoration
            const originalText = submitButton.textContent;
            submitButton.disabled = true;
            submitButton.textContent = "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E2A\u0E48\u0E07...";
            // Use setTimeout to let the UI update complete before making the request
            setTimeout(async ()=>{
                try {
                    const response = await fetch(form.action, {
                        method: "POST",
                        body: submissionData,
                        headers: {
                            Accept: "application/json"
                        }
                    });
                    if (response.ok) $58d30a8bb9adbbf5$export$7a49bbb4b7f656ab(bookingCode);
                    else $58d30a8bb9adbbf5$var$handleFormError();
                } catch (error) {
                    $58d30a8bb9adbbf5$var$handleFormError();
                } finally{
                    // Restore button state
                    submitButton.disabled = false;
                    submitButton.textContent = "\u0E08\u0E2D\u0E07\u0E04\u0E34\u0E27";
                }
            }, 50); // 50ms delay to ensure UI renders
            return; // Exit the main function since handling async in setTimeout
        }
        // Fallback if no submit button found
        try {
            const response = await fetch(form.action, {
                method: "POST",
                body: submissionData,
                headers: {
                    Accept: "application/json"
                }
            });
            if (response.ok) $58d30a8bb9adbbf5$export$7a49bbb4b7f656ab(bookingCode);
            else $58d30a8bb9adbbf5$var$handleFormError();
        } catch (error) {
            $58d30a8bb9adbbf5$var$handleFormError();
        }
    });
}
function $58d30a8bb9adbbf5$export$fa28a3a1712d2d0a() {}


function $5ef3dc9b08586e6e$export$e1b6310ce960b68() {
    (0, $fa1e525c94b2273d$export$4afef03e60e8adb5)();
    (0, $b8f4f765ee223ca8$export$fd2d1ddfa9193fe4)();
    (0, $e8e79bda60d9189f$export$3604f5fb8154211)();
    (0, $58d30a8bb9adbbf5$export$9ba86a8937f38dd)();
    (0, $58d30a8bb9adbbf5$export$fa28a3a1712d2d0a)();
}



// Centralized configuration - change links here and update everywhere
const $a60c51a7ac62daa9$export$19d8ac5a8a3af474 = {
    facebook: "https://www.facebook.com/share/1GuPWm5WMT",
    line: "https://line.me/ti/p/hJdG41iKRb",
    instagram: "https://www.instagram.com/ploy.tip",
    tiktok: "https://www.tiktok.com/@ploy.tip"
};
const $a60c51a7ac62daa9$export$970c6d219c1734d3 = [
    {
        text: "\u0E08\u0E2D\u0E07\u0E04\u0E34\u0E27",
        href: "index.html#contact"
    },
    {
        text: "\u0E23\u0E35\u0E27\u0E34\u0E27",
        href: "reviews.html"
    },
    {
        text: "\u0E02\u0E31\u0E49\u0E19\u0E15\u0E2D\u0E19\u0E43\u0E19\u0E01\u0E32\u0E23\u0E14\u0E39",
        href: "steps.html"
    },
    {
        text: "\u0E41\u0E1B\u0E25\u0E07\u0E40\u0E27\u0E25\u0E32",
        href: "time.html"
    }
];
function $a60c51a7ac62daa9$export$a4e4d9bf642d78d0() {
    const footer = document.querySelector('footer.footer');
    if (!footer) return;
    footer.innerHTML = `
    <div class="container">
      <a rel="noreferrer" href="#top" class="back-to-top">
        <i class="fa fa-angle-up fa-2x" aria-hidden="true"></i>
      </a>
      <div class="social-links">
        <a rel="noreferrer" href="${$a60c51a7ac62daa9$export$19d8ac5a8a3af474.line}" target="_blank">
          <i class="fab fa-line"></i>
        </a>
        <a rel="noreferrer" href="${$a60c51a7ac62daa9$export$19d8ac5a8a3af474.facebook}" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
        <a rel="noreferrer" href="${$a60c51a7ac62daa9$export$19d8ac5a8a3af474.instagram}" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
        <a rel="noreferrer" href="${$a60c51a7ac62daa9$export$19d8ac5a8a3af474.tiktok}" target="_blank">
          <i class="fab fa-tiktok"></i>
        </a>
      </div>

      <div class="footer-links">
        ${$a60c51a7ac62daa9$export$970c6d219c1734d3.map((link)=>`
          <div class="footer__text" style="margin: 5px 0">
            <a href="${link.href}">${link.text}</a>
          </div>
        `).join('')}
      </div>

      <hr />

      <p class="footer__text">
        \xa9 2021 - Template developed by
        <a rel="noreferrer" href="https://github.com/cobiwave" target="_blank">
          Jacobo Mart\xednez
        </a>
      </p>
    </div>
  `;
}


function $3eb997480dda6820$export$688410531deaa646() {
    document.querySelectorAll(".review-carousel").forEach((carousel)=>{
        const track = carousel.querySelector(".review-carousel__track");
        const prevBtn = carousel.querySelector(".review-carousel__btn--prev");
        const nextBtn = carousel.querySelector(".review-carousel__btn--next");
        if (!track || !prevBtn || !nextBtn) return;
        // Cards have varying widths, so pages by most of the visible width and lets scroll-snap align the result
        const scrollByPage = (direction)=>{
            track.scrollBy({
                left: direction * track.clientWidth * 0.8,
                behavior: "smooth"
            });
        };
        // Tolerance absorbs sub-pixel rounding and the snap padding at the scroll edges
        const EDGE_TOLERANCE_PX = 10;
        const updateButtons = ()=>{
            prevBtn.disabled = track.scrollLeft <= EDGE_TOLERANCE_PX;
            nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - EDGE_TOLERANCE_PX;
        };
        prevBtn.addEventListener("click", ()=>scrollByPage(-1));
        nextBtn.addEventListener("click", ()=>scrollByPage(1));
        track.addEventListener("scroll", updateButtons, {
            passive: true
        });
        window.addEventListener("resize", updateButtons);
        updateButtons();
    });
}


const $7359e95191dc376c$var$CARD_SELECTOR = ".review-card";
const $7359e95191dc376c$var$SWIPE_THRESHOLD_PX = 50;
function $7359e95191dc376c$var$createDialog() {
    const dialog = document.createElement("dialog");
    dialog.className = "review-lightbox";
    dialog.setAttribute("aria-label", "\u0E23\u0E35\u0E27\u0E34\u0E27");
    dialog.innerHTML = `
    <button type="button" class="review-lightbox__close" aria-label="\u{E1B}\u{E34}\u{E14}">
      <i class="fas fa-times"></i>
    </button>
    <button type="button" class="review-lightbox__nav review-lightbox__nav--prev" aria-label="\u{E23}\u{E35}\u{E27}\u{E34}\u{E27}\u{E01}\u{E48}\u{E2D}\u{E19}\u{E2B}\u{E19}\u{E49}\u{E32}">
      <i class="fas fa-chevron-left"></i>
    </button>
    <img class="review-lightbox__image" alt="" />
    <button type="button" class="review-lightbox__nav review-lightbox__nav--next" aria-label="\u{E23}\u{E35}\u{E27}\u{E34}\u{E27}\u{E16}\u{E31}\u{E14}\u{E44}\u{E1B}">
      <i class="fas fa-chevron-right"></i>
    </button>
    <p class="review-lightbox__counter"></p>
  `;
    document.body.appendChild(dialog);
    return dialog;
}
function $7359e95191dc376c$export$8da7a594aa63749f() {
    if (!document.querySelector($7359e95191dc376c$var$CARD_SELECTOR) && !document.getElementById("reviews-container")) return;
    if (typeof HTMLDialogElement !== "function") return;
    const dialog = $7359e95191dc376c$var$createDialog();
    const image = dialog.querySelector(".review-lightbox__image");
    const counter = dialog.querySelector(".review-lightbox__counter");
    let cards = [];
    let currentIndex = 0;
    const show = (index)=>{
        if (!cards.length) return;
        currentIndex = (index + cards.length) % cards.length;
        const source = cards[currentIndex].querySelector("img");
        image.src = source.currentSrc || source.src;
        image.alt = source.alt;
        counter.textContent = `${currentIndex + 1} / ${cards.length}`;
    };
    // Delegated so cards rendered later by reviews.js are also handled
    document.addEventListener("click", (event)=>{
        const card = event.target.closest($7359e95191dc376c$var$CARD_SELECTOR);
        if (!card) return;
        cards = [
            ...document.querySelectorAll($7359e95191dc376c$var$CARD_SELECTOR)
        ];
        show(cards.indexOf(card));
        dialog.showModal();
    });
    dialog.querySelector(".review-lightbox__close").addEventListener("click", ()=>dialog.close());
    dialog.querySelector(".review-lightbox__nav--prev").addEventListener("click", ()=>show(currentIndex - 1));
    dialog.querySelector(".review-lightbox__nav--next").addEventListener("click", ()=>show(currentIndex + 1));
    // Clicks on the dialog element itself land on the backdrop area
    dialog.addEventListener("click", (event)=>{
        if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener("keydown", (event)=>{
        if (event.key === "ArrowLeft") show(currentIndex - 1);
        if (event.key === "ArrowRight") show(currentIndex + 1);
    });
    let touchStartX = null;
    dialog.addEventListener("touchstart", (event)=>{
        touchStartX = event.touches[0].clientX;
    }, {
        passive: true
    });
    dialog.addEventListener("touchend", (event)=>{
        if (touchStartX === null) return;
        const deltaX = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(deltaX) < $7359e95191dc376c$var$SWIPE_THRESHOLD_PX) return;
        show(deltaX > 0 ? currentIndex - 1 : currentIndex + 1);
    });
    dialog.addEventListener("close", ()=>{
        image.removeAttribute("src");
    });
}


// Initialize scroll reveal and tilt effects
(0, $6f019d1f45ba2738$export$2e2bcd8739ae039)((0, $d859da13df4a30ff$export$adcf75ad64a03007), (0, $d859da13df4a30ff$export$9c21a3269931e1e6));
(0, $b8855ed206bb3c2e$export$2e2bcd8739ae039)();
// Apply footer from config (includes social links)
document.addEventListener("DOMContentLoaded", (0, $a60c51a7ac62daa9$export$a4e4d9bf642d78d0));
document.addEventListener("DOMContentLoaded", ()=>{
    (0, $3eb997480dda6820$export$688410531deaa646)();
    (0, $7359e95191dc376c$export$8da7a594aa63749f)();
});
// Initialize booking form when DOM is ready (only if form exists)
function $35da740d59af89ba$var$initializePage() {
    // Only initialize booking form if the form exists on this page
    const bookingForm = document.getElementById("bookingForm");
    if (bookingForm) {
        (0, $5ef3dc9b08586e6e$export$e1b6310ce960b68)();
        // Add a click listener to the test button
        const testAlertBtn = document.getElementById("test-alert-btn");
        if (testAlertBtn) testAlertBtn.addEventListener("click", ()=>{
            (0, $58d30a8bb9adbbf5$export$7a49bbb4b7f656ab)("TEST12");
        });
    }
}
// Use jQuery if available, otherwise use DOMContentLoaded
if (typeof $ !== 'undefined') $(function() {
    $35da740d59af89ba$var$initializePage();
});
else document.addEventListener("DOMContentLoaded", $35da740d59af89ba$var$initializePage);


//# sourceMappingURL=ploytip.6119596a.js.map
